export const manage_recordings_api = {
  get_recordings: "host/zoom/recordings/unmapped/list",
  save_recordings_sections: "host/zoom/recordings/map",
};
